<nav class="submenu__container">
  @for (item of environment.submenu; track item) {
    <div
      class="submenu__container__item"
      [attr.data-testid]="item?.dataTestId || 'unknown'"
    [ngStyle]="{
      display:
        (item.dataTestId === 'listagem' ||
          item.dataTestId === 'revisao' ||
          item.dataTestId === 'usuarios-excluidos') &&
        hideButtons
          ? 'none'
          : ''
    }"
      [routerLinkActive]="['is-active']"
      >
      @if (item.dataTestId === 'auto-atendimento' || item.dataTestId ==='central-de-ajuda';) {
        <a (click)="redirect({ url: item.url, targetClientId: item.clientId || '' });" 
          plAnalyticsButton 
          [launchLabel]="item.text"
          launchSection="Clique"
          launchSiteSection="PortalDeLogons"
        >
          <span class="submenu__container__item__icon material-icons">{{ item?.icon }}</span>
          <span class="submenu__container__item__text">{{ item?.text }}</span>
        </a>
      } @else {
        <a
          [routerLink]="item?.url"
          [attr.data-testid]="item?.dataTestId || 'unknown'"
          >
            <span class="submenu__container__item__icon material-icons">{{ item.icon }}</span>
            <span class="submenu__container__item__text">{{ item.text }}</span>
        </a>
      }
    </div>
    }
  </nav>
